import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Store } from '@ngxs/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Miscellanious } from '@ops/global-config';
import { SettingsEditState, DisableSettingsEdit } from '@ops/services';
import {
  CompanyService,
  LocalStorageService,
  NameFilter,
  OpsSubscriptionModalService,
  PricingPlanMapped,
  SessionManagerService,
  StripeService,
  StripeStatus,
  SubscriptionStatus,
} from '@ops/shared-types';
import { MappedBillingHistoryInvoice } from 'legacy/shared/shared-types/src/lib/models/billing-history.model';
import { MappedAddOn } from 'legacy/shared/shared-types/src/lib/models/stripe-product-addons.model';
import { forkJoin, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'ops-subscription-settings',
  templateUrl: './ops-subscription-settings.component.html',
  styleUrl: './ops-subscription-settings.component.scss',
})
export class OpsSubscriptionSettingsComponent implements OnInit, OnDestroy {
  editState$: Observable<boolean> = inject(Store).select(
    SettingsEditState.getEditState
  );

  saveState$: Observable<boolean> = inject(Store).select(
    SettingsEditState.getSaveState
  );

  isPreview = true;
  isChangingPlan = false;
  isCreatingPlan = false;
  // stripeUrl?: SafeResourceUrl;
  selectedPlanId = null;
  subscriptionItemId = null;
  selectedSubscriptionData: any;
  // selectedPlanId = 'prod_RuFNKXTXGxa7Ij';
  subscriptionPlans?: Array<PricingPlanMapped>;

  initialLoading: boolean = true;

  subs: Array<Subscription> = [];

  allSubscriptions: Array<any> = [];

  selectedInterval: string = 'annual';
  selectedCurrency: string = 'USD';

  allUserCompanies: NameFilter[];

  billingHistoryList: MappedBillingHistoryInvoice[];

  showCreateNewOrganisation = false;
  showPaymentMethodsModal = false;
  subscriptionId;
  iconInfoVisible: boolean = false;
  iconInfoVisibleId: string = '';
  mappedAddOns: MappedAddOn[];
  historyLoaded: boolean = true;
  internalLoading: boolean = false;
  stripeError: boolean = false;
  confirmSubscription: Subscription;

  noExistingSubscriptions = false;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private stripeService: StripeService,
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private session: SessionManagerService,
    private modalService: OpsSubscriptionModalService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // Start in preview mode
    this.isPreview = true;
    
    const eState = this.editState$.subscribe((isEditing: any) => {
      this.isPreview = !isEditing;
    });

    const sState = this.saveState$.subscribe((saveChanges: any) => {
      if (saveChanges === true) {
        // console.log('SAVE CHANGES');

        this.store.dispatch(new DisableSettingsEdit());
      }
    });

    const sProd = this.stripeService
      .getStripeProducts()
      .subscribe((stripeProducts: PricingPlanMapped[]) => {
        this.subscriptionPlans = [...stripeProducts];
      });

    // const uSubs = this.stripeService
    //   .getUserSubscriptions(companyId)
    //   .subscribe((userSubscription) => {
    //     if (userSubscription) {
    //       this.selectedPlanId = userSubscription?.stripePriceId;
    //       this.selectedSubscriptionData = userSubscription;
    //     }
    //     this.initialLoading = false;
    //   });

    const statusValue = this.route.snapshot.queryParamMap.get('status');
    if (statusValue) {
      if (statusValue === 'successfull' || statusValue === 'success') {
        this.showPaymentMethodSuccessModal();
      } else if (statusValue === 'error') {
        this.showPaymentMethodErrorModal();
      }
    }

    this.refetchAll();

    this.subs.push(eState);
    this.subs.push(sState);

    this.subs.push(sProd);

    // this.subs.push(companiesSub);

    // this.stripeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://checkout.stripe.com/c/pay/cs_test_a1xPDR0h6UsafmdWy0YAzFlQESGPvLMFZ6YaBADLCbIyTN9NZZAsvGdwc2#fidkdWxOYHwnPyd1blpxYHZxWjA0VF1zfXZASVFBRGYxdEZCMWlJPFFjYFVLaW5xTW0xXWZIM219dnRPSzBEY2lHYUxJSDI0U0FGQUtmQTF2bVVpZExxNHB8cTNGT0dtZ0hhZlFmX01EQk1DNTU1PEdXUDU0RCcpJ2N3amhWYHdzYHcnP3F3cGApJ2lkfGpwcVF8dWAnPyd2bGtiaWBabHFgaCcpJ2BrZGdpYFVpZGZgbWppYWB3dic%2FcXdwYHgl');
  }

  setIconInfoVisible = (value: boolean, id: string) => {
    this.iconInfoVisible = value;
    this.iconInfoVisibleId = id;
  };

  refetchAll(changedToSelectSubscriptionId?: string) {
    const allUserCompanies$ = this.getAllUserCompanies();
    const allUserSubscriptions$ = this.getAllUserSubscriptions();
    const allProductAddons$ = this.getAllProductAddons();

    const forkJoinSub = forkJoin([
      allUserCompanies$,
      allUserSubscriptions$,
      allProductAddons$,
    ]).subscribe({
      next: ([userCompanies, userSubscriptions, allProductAddons]: any) => {
        // console.log(
        //   //   'Companies/Subscriptions',
        //   //   userCompanies.length,
        //   //   userSubscriptions.length
        //   'allProductAddons',
        //   allProductAddons
        // );

        this.mappedAddOns = allProductAddons;

        if (userSubscriptions.length) {
          const selectedPriceIdOfFirstSubscription =
            userSubscriptions[0]?.stripePriceId;

          this.selectedCurrency =
            this.stripeService.getSubscriptionCurrency(
              selectedPriceIdOfFirstSubscription,
              this.subscriptionPlans
            ) || 'USD';

          this.allUserCompanies = userCompanies;
          const usersSubs = userSubscriptions.map((userSubs) => {
            return {
              ...userSubs, 
              companyName: userCompanies.find(
                (userComp) => userComp._id === userSubs.company
              )?.name,
            };
          });

          const connectedSubs = usersSubs.filter(
            (withCompany: any) => !!withCompany?.company
          ); //;
          const emptySubs = usersSubs.filter(
            (withoutCompany: any) => !withoutCompany?.company
          );

          this.allSubscriptions = [...connectedSubs, ...emptySubs].sort(
            (a, b) => a?.companyName?.localeCompare(b?.companyName)
          );

          const selectedCompanySubscription = this.allSubscriptions.find(
            (subscriptionItem) => {
              return !!subscriptionItem.company;
            }
          );
          if (changedToSelectSubscriptionId) {
            const changedToSelect = this.allSubscriptions.find(
              (subscriptionItem) => {
                return subscriptionItem._id === changedToSelectSubscriptionId;
              }
            );
            this.subscriptionItemId = changedToSelect?._id;
            this.selectedPlanId = changedToSelect?.stripePriceId;
            this.selectedSubscriptionData = changedToSelect;
          } else if (selectedCompanySubscription) {
            this.subscriptionItemId = selectedCompanySubscription?._id;
            this.selectedPlanId = selectedCompanySubscription?.stripePriceId;
            this.selectedSubscriptionData = selectedCompanySubscription;
          } else {
            const firstEmpty = this.allSubscriptions[0];
            this.subscriptionItemId = firstEmpty?._id;
            this.selectedPlanId = firstEmpty?.stripePriceId;
            this.selectedSubscriptionData = firstEmpty;
          }

          this.getBillingHistoryItems();

          this.initialLoading = false;
          this.internalLoading = false;
        } else {
          this.noExistingSubscriptions = true;
          this.initialLoading = false;
          this.internalLoading = false;
          this.isCreatingPlan = true; 
          this.isChangingPlan = true;
          this.selectedPlanId = null;
        }
      },
      error: (error) => {
        this.initialLoading = false;
        this.internalLoading = false;
        this.stripeError = true;
        // console.error('An error occurred:', error);
      },
      complete: () => {
        // console.log('All updates completed.');
      },
    });
    this.subs.push(forkJoinSub);
  }

  addOnUpdates(planUpdateData: any) {
    this.allSubscriptions = this.allSubscriptions.map((subItem) => {
      if (subItem._id === planUpdateData._id) {
        return {
          ...subItem,
          maxRealProjectsInCompany: planUpdateData.maxRealProjectsInCompany,
          maxUserPerCompany: planUpdateData.maxUserPerCompany,
          limitations: {
            maxRealProjectsInCompany: planUpdateData.maxRealProjectsInCompany,
            maxUserPerCompany: planUpdateData.maxUserPerCompany,
          },
        };
      }

      return {
        ...subItem,
      };
    });

    const changedToSelect = this.allSubscriptions.find((subscriptionItem) => {
      return subscriptionItem._id === planUpdateData._id;
    });

    this.selectedSubscriptionData = changedToSelect;
    this.getBillingHistoryItems();
    this.showSuccessModal();
    // console.log('PLAN UPDATE DATA', planUpdateData);
  }

  getBillingHistoryItems() {
    const bhProd = this.stripeService
      .getBillingHistory(this.subscriptionItemId)
      .subscribe((billingHistoryItems: any[]) => {
        // TODO missmatch models MappedBillingHistory
        this.billingHistoryList = billingHistoryItems.map((bItem) => {
          return {
            ...bItem
          };
        });
        // this.historyLoaded = true;
      });
    this.subs.push(bhProd);
  }

  get currencyExchangeSymbol() {
    return Miscellanious.currencySymbolFromCode('en-US', 'usd');
  }

  formatDateWithTranslatedMonth(date: any): string {
    if (!date) return '';
    
    let dateObj: Date;
    
    // Handle different date formats
    if (typeof date === 'string') {
      dateObj = new Date(date);
    } else if (date instanceof Date) {
      dateObj = date;
    } else if (typeof date === 'number') {
      // Handle timestamp
      dateObj = new Date(date);
    } else if (date && typeof date === 'object' && date.toDate) {
      // Handle Firestore timestamp or similar
      dateObj = date.toDate();
    } else {
      // console.log('Unknown date format:', date, typeof date);
      return '';
    }
    
    if (isNaN(dateObj.getTime())) {
      // console.log('Invalid date:', date, 'parsed as:', dateObj);
      return '';
    }
    
    const month = dateObj.getMonth();
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    
    const monthNames = [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december'
    ];
    
    const translatedMonth = this.translateService.instant(monthNames[month]);
    return `${translatedMonth} ${day}, ${year}`;
  }

  onSubscriptionSelect(subscriptionItem) {
    // console.log('subscriptionItem', subscriptionItem);
    if (subscriptionItem) {
      // this.historyLoaded = false;
      this.subscriptionItemId = subscriptionItem?._id;
      this.selectedPlanId = subscriptionItem?.stripePriceId;
      this.selectedSubscriptionData = subscriptionItem;

      this.getBillingHistoryItems();
    }
  }

  onGoBackClick() {
    this.isChangingPlan = false;
    this.isCreatingPlan = false;

    const selectedCompanySubscription = this.allSubscriptions.find(
      (subscriptionItem) => {
        return !!subscriptionItem.company;
      }
    );
    if (selectedCompanySubscription) {
      this.subscriptionItemId = selectedCompanySubscription?._id;
      this.selectedPlanId = selectedCompanySubscription?.stripePriceId;
      this.selectedSubscriptionData = selectedCompanySubscription;
    } else if (this.allSubscriptions.length) {
      const firstEmpty = this.allSubscriptions[0];
      this.subscriptionItemId = firstEmpty?._id;
      this.selectedPlanId = firstEmpty?.stripePriceId;
      this.selectedSubscriptionData = firstEmpty;
    }
  }

  onCloseCreateCompany() {
    this.subscriptionId = null;
    this.showCreateNewOrganisation = false;
  }
  onCreatedCompany(newCompany: any) {
    // console.log('NEW COMPANY', newCompany);

    this.allUserCompanies.push(newCompany);
    this.allSubscriptions = this.allSubscriptions.map((subscriptionItem) => {
      if (subscriptionItem?._id === this.subscriptionId) {
        return {
          ...subscriptionItem,
          company: newCompany._id,
          companyName: newCompany.name,
        };
      }

      return {
        ...subscriptionItem,
      };
    });
    this.subscriptionId = null;
    this.showCreateNewOrganisation = false;

    this.session.attemptResumeSession();
  }

  onCreateNewSubscription() {
    this.selectedInterval = 'annual';
    this.selectedPlanId = null;
    this.isCreatingPlan = true;
    this.isChangingPlan = true;
  }

  onCreateNewCompany(subscriptionId) {
    this.subscriptionId = subscriptionId;
    this.showCreateNewOrganisation = true;
  }

  getAllUserCompanies() {
    return this.companyService.getCompanyFilters();
  }

  getAllUserSubscriptions() {
    return this.stripeService.getAllUserSubscriptions();
  }

  getAllProductAddons() {
    return this.stripeService.getStripeProductsAddons();
  }

  ngOnDestroy(): void {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    this.subs.forEach((s) => s.unsubscribe());
  }

  get showMonthly() {
    if (!this.selectedPlanId) return false;
    if (this.subscriptionPlans?.length > 0) {
      const selectedMatch = this.subscriptionPlans.find(
        (planItem) =>
          planItem.monthly[this.selectedCurrency]?.id === this.selectedPlanId
      );

      return !!selectedMatch;
    }
    return false;
  }

  get selectedPlanItem() {
    if (!this.selectedPlanId || !this.selectedCurrency) return null;
    if (this.allSubscriptions.length) {
      const selectedMatch = this.allSubscriptions.find(
        (subscriptionItem) =>
          subscriptionItem.stripePriceId === this.selectedPlanId
      );
      if (selectedMatch) {
        return selectedMatch.pricingPlanMapped;
      }
    }
    if (this.subscriptionPlans?.length > 0) {
      const selectedMatch = this.subscriptionPlans.find(
        (planItem) =>
          planItem.monthly[this.selectedCurrency]?.id === this.selectedPlanId ||
          planItem.yearly[this.selectedCurrency]?.id === this.selectedPlanId
      );
      return selectedMatch || null;
    }
    return null;
  }

  get showingMonthly(): boolean {
    return this.selectedInterval === 'monthly';
  }

  onIntervalChange(interval: string) {
    this.selectedInterval = interval;
  }

  onChangeCurrency(currency: string) {
    this.selectedCurrency = currency || 'USD';
  }

  onConfirmedChangingPlan(newPlan: string) {
    this.internalLoading = true;

    const changeSub = this.stripeService
      .changeUserSubscription(this.selectedSubscriptionData._id, newPlan)
      .subscribe({
        next: (resp: any) => {
          const respJson = JSON.parse(resp);
          if (respJson?._id) {
            this.showSuccessModal();
            // this.selectedPlanId = null;
            this.isCreatingPlan = false;
            this.isChangingPlan = false;
            this.refetchAll(respJson?._id);
          } else {
            this.internalLoading = false;
          }
        },
        error: (e) => {
          // console.log('error', e);
          this.internalLoading = false;
        },
      });
    this.subs.push(changeSub);
  }

  onConfirmChangePlan(newPlan: string) {
    const titleText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.CONFIRMATION');
    const confirmationText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.CHANGE_PLAN_CONFIRMATION');
    this.showConfirmationModal(
      titleText,
      confirmationText,
      this.onConfirmedChangingPlan.bind(this, newPlan)
    );
  }

  onSelectPlan(newPlan: string) {
    if (this.isCreatingPlan || !this.selectedSubscriptionData?._id) {
      const postSub = this.stripeService.postStripePlainId(newPlan).subscribe((resp: any) => {
        const respJson = JSON.parse(resp);
        if (respJson?.url) {
          window.open(respJson.url, '_self');
        }
      });
      this.subs.push(postSub);
    } else if (
      this.selectedSubscriptionData?._id &&
      this.selectedSubscriptionData?.status === StripeStatus.CANCELED
    ) {
      const postSubCanceled = this.stripeService
        .postStripePlainId(newPlan, this.selectedSubscriptionData.company)
        .subscribe((resp: any) => {
          const respJson = JSON.parse(resp);
          if (respJson?.url) {
            window.open(respJson.url, '_self');
          }
        });
      this.subs.push(postSubCanceled);
    } else {
      this.onConfirmChangePlan(newPlan);
    }
  }

  onChangePlan() {
    this.selectedInterval = this.showMonthly ? 'monthly' : 'annual';
    this.isChangingPlan = true;
  }

  updateCanceledSubscriptionStatusAndData (subscriptionData: any) {
    const updateCanceledSub = this.stripeService.getUserSubscriptionById(this.selectedSubscriptionData._id).subscribe((userSubscription: any) => {
      if (!this.selectedSubscriptionData?.company) {
        this.allSubscriptions = this.allSubscriptions.map((aSubItem) => {
          if (aSubItem._id === this.selectedSubscriptionData._id) {
            return {
              ...userSubscription,
              companyName: this.allUserCompanies.find(
                (userComp) => userComp._id === aSubItem.company
              )?.name,
            };
          }

          return {
            ...aSubItem,
          };
        });

        if (this.allSubscriptions.length) {
          const firstEmpty = this.allSubscriptions[0];
          this.subscriptionItemId = firstEmpty?._id;
          this.selectedPlanId = firstEmpty?.stripePriceId;
          this.selectedSubscriptionData = firstEmpty;
        } else {
          this.isCreatingPlan = true;

          this.subscriptionItemId = null;
          this.selectedPlanId = null;
          this.selectedSubscriptionData = null;
        }
      } else {
        if (
          this.localStorageService.getCurrentCompany()?._id ===
          this.selectedSubscriptionData.company
        ) {
          this.localStorageService.clearAllProjectsTs();
        }

        this.allSubscriptions = this.allSubscriptions.map((aSubItem) => {
          if (aSubItem._id === this.selectedSubscriptionData._id) {
            return {
              ...userSubscription,
              companyName: this.allUserCompanies.find(
                (userComp) => userComp._id === aSubItem.company
              )?.name,
            };
          }

          return {
            ...aSubItem,
          };
        });

        this.selectedSubscriptionData = userSubscription;
      }
    });
    this.subs.push(updateCanceledSub);
  }

  updateDefaultPaymentMethodForSubscription() {
    const updateDefaultSub = this.stripeService.getUserSubscriptionById(this.selectedSubscriptionData._id).subscribe((userSubscription: any) => {
      // Update the subscription in the allSubscriptions array
      this.allSubscriptions = this.allSubscriptions.map((aSubItem) => {
        if (aSubItem._id === this.selectedSubscriptionData._id) {
          return {
            ...aSubItem,
            last4: userSubscription.last4,
            defaultPaymentMethodId: userSubscription.defaultPaymentMethodId,
          };
        }

        return {
          ...aSubItem,
        };
      });

      // Update the selected subscription data
      this.selectedSubscriptionData = userSubscription;

    });
    this.subs.push(updateDefaultSub);
  }

  updateResumedSubscriptionStatusAndData(subscriptionData: any) {
    const updateResumedSub = this.stripeService.getUserSubscriptionById(this.selectedSubscriptionData._id).subscribe((userSubscription: any) => {
      // Update the subscription in the allSubscriptions array
      this.allSubscriptions = this.allSubscriptions.map((aSubItem) => {
        if (aSubItem._id === this.selectedSubscriptionData._id) {
          return {
            ...userSubscription,
            companyName: this.allUserCompanies.find(
              (userComp) => userComp._id === aSubItem.company
            )?.name,
          };
        }

        return {
          ...aSubItem,
        };
      });

      // Update the selected subscription data
      this.selectedSubscriptionData = userSubscription;

      // Show success modal
      this.showSuccessModal();

      // Refresh billing history
      this.getBillingHistoryItems();
    });
    this.subs.push(updateResumedSub);
  }

  startCancelSubscription() {
    const cancelSub = this.stripeService
      .cancelUserSubscriptionById(this.selectedSubscriptionData._id)
      .subscribe((resp: any) => {
        // console.log('CANCELED SUBSCRIPTION RESP => ', resp);

        // this.selectedPlanId = null;
        // this.isCreatingPlan = false;
        // this.isChangingPlan = false;
        this.updateCanceledSubscriptionStatusAndData(this.selectedSubscriptionData);
        

        // this.allSubscriptions = [];
        // if(selectFirstElse) {
        // this.refetchAll(selectFirstElse?._id);
      });
    this.subs.push(cancelSub);
  }

  startResumeSubscription() {
    this.internalLoading = true;
    const resumeSub = this.stripeService
      .stripeSubscriptionResume(this.selectedSubscriptionData._id)
      .subscribe({
        next: (resp: any) => {
          // console.log('RESUMED SUBSCRIPTION RESP => ', resp);
          if (resp) {
            const respJson = JSON.parse(resp);
            // Open the Stripe URL in the same window
            window.open(respJson.url, '_self');
          } else {
            // If no URL is provided, update the subscription status and data
            this.updateResumedSubscriptionStatusAndData(this.selectedSubscriptionData);
          }
          this.internalLoading = false;
        },
        error: (error) => {
          // console.log('Resume subscription error:', error);
          this.internalLoading = false;
          this.showErrorModal();
        }
      });
    this.subs.push(resumeSub);
  }

  onCancelSubscription() {
    const titleText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.CONFIRM_CANCELLATION');
    const confirmationText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.CANCEL_SUBSCRIPTION_CONFIRMATION');
    this.showConfirmationModal(
      titleText,
      confirmationText,
      this.startCancelSubscription.bind(this)
    );
  }

  onResumeSubscription() {
    const titleText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.CONFIRMATION');
    const confirmationText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.RESUME_SUBSCRIPTION_CONFIRMATION');
    this.showConfirmationModal(
      titleText,
      confirmationText,
      this.startResumeSubscription.bind(this)
    );
  }

  showSuccessModal() {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    const modalText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.SUBSCRIPTION_SUCCESSFUL');
    this.confirmSubscription = this.modalService
      .openModal({
        statusType: SubscriptionStatus.SUCCESS,
        modalText: modalText,
      })
      .subscribe((confirmed) => {
        if (confirmed !== null) {
          // Handle confirmation (only relevant for confirmation dialogs)
          // console.log('User confirmed:', confirmed);
        }
      });
  }

  showErrorModal() {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    } 
    const modalText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.SUBSCRIPTION_ERROR');

    this.modalService.openModal({
      statusType: SubscriptionStatus.ERROR,
      modalText: modalText,
    });
  }

  showPaymentMethodSuccessModal() {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    const modalText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.PAYMENT_METHOD_SUCCESS');
    this.modalService
      .openModal({
        statusType: SubscriptionStatus.SUCCESS,
        modalText: modalText,
      })
      .subscribe((confirmed) => {
        if (confirmed !== null) {
          // Handle confirmation (only relevant for confirmation dialogs)
          // console.log('User confirmed:', confirmed);
        }
      });
    
    // Remove status parameter from URL immediately after showing modal
    this.removeStatusParameterFromUrl();
  }

  showPaymentMethodErrorModal() {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    const modalText = this.translateService.instant('OPS_SUBSCRIPTION_SETTINGS.PAYMENT_METHOD_ERROR');
    this.modalService.openModal({
      statusType: SubscriptionStatus.ERROR,
      modalText: modalText,
    });
    // Remove status parameter from URL immediately after showing modal
    this.removeStatusParameterFromUrl();
  }

  showConfirmationModal(
    titleText: string,
    bodyText: string,
    confirmationCallBack: () => void,
    cancelationCallBack?: () => void
  ) {
    if (this.confirmSubscription?.unsubscribe) {
      this.confirmSubscription.unsubscribe();
    }
    this.confirmSubscription = this.modalService
      .openModal({
        statusType: SubscriptionStatus.CONFIRMATION,
        modalTitle: titleText,
        modalText: bodyText,
      })
      .subscribe((confirmed) => {
        if (confirmed) {
          // User confirmed
          // console.log('User confirmed cancellation');
          confirmationCallBack();
        } else {
          // User declined
          // console.log('User cancelled the action');
          cancelationCallBack && cancelationCallBack();
        }
      });
  }

  onChangePaymentMethod() {
    this.showPaymentMethodsModal = true;
  }

  onClosePaymentMethodsModal() {
    this.showPaymentMethodsModal = false;
  }

  onPaymentMethodSelected(paymentMethod: any) {
    // Handle payment method selection if needed
    // For now, just close the modal
    this.showPaymentMethodsModal = false;
  }

  /**
   * Removes the status parameter from the URL after showing status modals
   */
  private removeStatusParameterFromUrl() {
    const currentUrl = this.router.url;
    // console.log('Current URL before cleanup:', currentUrl);
    
    const urlTree = this.router.parseUrl(currentUrl);
    
    // Create a new query params object without the status parameter
    const newQueryParams = { ...urlTree.queryParams };
    delete newQueryParams['status'];
    
    // console.log('Query params after cleanup:', newQueryParams);
    
    // Navigate to the same route without the status parameter
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: newQueryParams,
      replaceUrl: true
    });
  }
}
